import { FormattedMessage } from 'react-intl';

import { usePaymentIntentContext } from '@/providers/PaymentIntentProvider/context';

import { Link } from './Link';

export const Footer = () => {
  const {
    data: { company_name, company_cs_url, is_insured },
  } = usePaymentIntentContext();

  return (
    <footer className="text-center text-[13px]/[20px] text-ink-500 space-y-4 pb-8">
      <p>
        <FormattedMessage
          id="footer.line-1"
          values={{
            easyship: 'Easyship', // to prevent from being translated
            company: company_name,
            contact: (
              <Link href={company_cs_url}>
                <FormattedMessage id="global.contact" /> {company_name}
              </Link>
            ),
          }}
        />
      </p>
      {!is_insured && (
        <p>
          <FormattedMessage
            id="footer.line-2"
            values={{
              termsOfService: (
                <Link href="https://www.easyship.com/legal/collect-service">
                  Easyship&apos;s <FormattedMessage id="global.terms-and-conditions" />
                </Link>
              ),
            }}
          />
        </p>
      )}
    </footer>
  );
};
